import { regions, statuses, years } from "@/mocks/anime";

export type SortKey = "popularity" | "updated";

interface FilterBarProps {
  region: string;
  year: string;
  status: string;
  sort: SortKey;
  onRegionChange: (v: string) => void;
  onYearChange: (v: string) => void;
  onStatusChange: (v: string) => void;
  onSortChange: (v: SortKey) => void;
}

function Select({
  label,
  value,
  options,
  onChange,
}: {
  label: string;
  value: string;
  options: string[];
  onChange: (v: string) => void;
}) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-foreground-500 whitespace-nowrap">{label}</span>
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="appearance-none h-9 pl-3 pr-9 rounded-md bg-background-50 border border-background-200 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 cursor-pointer min-w-[92px]"
        >
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
        <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 pointer-events-none" />
      </div>
    </div>
  );
}

export default function FilterBar({
  region,
  year,
  status,
  sort,
  onRegionChange,
  onYearChange,
  onStatusChange,
  onSortChange,
}: FilterBarProps) {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center gap-4 lg:justify-between p-4 rounded-lg bg-background-100 border border-background-200/70">
      <div className="flex items-center flex-wrap gap-4">
        <Select label="地区" value={region} options={regions} onChange={onRegionChange} />
        <Select label="年份" value={year} options={years} onChange={onYearChange} />
        <Select label="状态" value={status} options={statuses} onChange={onStatusChange} />
      </div>

      <div className="flex items-center gap-2">
        <div className="flex items-center gap-1 p-1 rounded-full bg-background-50 border border-background-200">
          <button
            onClick={() => onSortChange("popularity")}
            className={`px-3.5 py-1.5 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
              sort === "popularity" ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:bg-background-100"
            }`}
          >
            按热度
          </button>
          <button
            onClick={() => onSortChange("updated")}
            className={`px-3.5 py-1.5 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
              sort === "updated" ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:bg-background-100"
            }`}
          >
            按更新时间
          </button>
        </div>
      </div>
    </div>
  );
}